import manifest from '@tunasong/manifest'
import { useState } from 'react'

const STORAGE_KEY = 'tuna.last-seen-release'

const readLastSeen = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined
  }
  try {
    return window.localStorage.getItem(STORAGE_KEY) ?? undefined
  } catch {
    return undefined
  }
}

const writeLastSeen = (version: string) => {
  if (typeof window === 'undefined') {
    return
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, version)
  } catch {
    /* localStorage unavailable — ignore */
  }
}

const compareVersion = (a: string, b: string) => {
  const aParts = a.split('.').map(Number)
  const bParts = b.split('.').map(Number)
  for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
    const aPart = aParts[i] ?? 0
    const bPart = bParts[i] ?? 0
    if (aPart < bPart) {
      return 1
    }
    if (aPart > bPart) {
      return -1
    }
  }
  return 0
}

/** Get the ID of the release notes to show. If `null` no (new) release notes are available. */
export const useReleaseNotes = () => {
  const [latestSeenRelease, setLatestSeenRelease] = useState<string | undefined>(readLastSeen)

  const latestRelease = manifest.releases.toSorted((a, b) => compareVersion(a.version, b.version))[0]

  const latestUnread =
    latestRelease && latestRelease.version !== latestSeenRelease ? latestRelease : undefined

  const setReadVersion = (version: string) => {
    writeLastSeen(version)
    setLatestSeenRelease(version)
  }

  return { releaseNotes: manifest.releases, latestUnread, setReadVersion, isReady: true }
}
